import './madefromscratch/style';
import FormStructure from './madefromscratch/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js